import { render } from "./Questions.vue?vue&type=template&id=fdbb51c6&scoped=true&lang=pug"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=fdbb51c6&lang=scss&scoped=true"
import "./Questions.vue?vue&type=style&index=1&id=fdbb51c6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbb51c6"]])

export default __exports__